exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3loe-Zk9vS0_Ipp8T5CQ3Y{height:100%;overflow-y:scroll}._3loe-Zk9vS0_Ipp8T5CQ3Y .msgList{padding-bottom:60px!important}._3loe-Zk9vS0_Ipp8T5CQ3Y .post{z-index:99;background-color:#fff;height:60px;position:fixed;width:100%;bottom:0;padding:0 20px 10px}._3loe-Zk9vS0_Ipp8T5CQ3Y .input-sec{width:80%!important;padding-right:10px;display:inline-block}._3loe-Zk9vS0_Ipp8T5CQ3Y .input-sec input{line-height:40px!important}._3loe-Zk9vS0_Ipp8T5CQ3Y .postBtn{width:20%;display:inline-block;min-width:0!important;line-height:48px!important}", ""]);

// exports
exports.locals = {
	"styles": "_3loe-Zk9vS0_Ipp8T5CQ3Y"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/containers/Chat/styles.scss
 ** module id = 511
 ** module chunks = 0
 **/